if ("undefined" === typeof NHS || null === NHS) { NHS = {}; }
NHS.loadCss = function (cssFileName) {
    var rules = document.querySelector('link[rel="stylesheet"][href="' + cssFileName + '"]');
    if (rules) return;
    rules = document.createElement("link");
    rules.rel = "stylesheet";
    rules.href = cssFileName;
    document.documentElement.appendChild(rules);
};